import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=1fa93727&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1fa93727')) {
      api.createRecord('1fa93727', component.options)
    } else {
      api.reload('1fa93727', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=1fa93727&", function () {
      api.rerender('1fa93727', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwmGIk7Rz01W/JS/cancellationPolicy.vue"
export default component.exports